import permissions from "app/permissions";
import { ACTIVITIES, ActivityServicePath, FOREIGN_LANGUAGES } from "utils/constants";
import LanguageIcon from "@mui/icons-material/Language";
import ListForeignLanguagesSchedules from "./List";
import CreateForeignLanguagesSchedules from "./Create";
import EditForeignLanguagesSchedules from "./Edit";
import ShowForeignLanguagesSchedules from "./Show";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MGU],
  icon: <LanguageIcon />,
  name: ActivityServicePath + ACTIVITIES + "/" + FOREIGN_LANGUAGES,
  title: "Разписания чужди езици",
  list: <ListForeignLanguagesSchedules />,
  create: <CreateForeignLanguagesSchedules />,
  edit: <EditForeignLanguagesSchedules />,
  show: <ShowForeignLanguagesSchedules />,
  permission: permissions.canPreviewForeignLanguageActivities,
};
